import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import "./Registration.css";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  InputLabel,
  TextField,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Mulish, sans-serif ",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "20px",
    fontFamily: "Mulish, sans-serif ",
  },
}));

const SignIn = ({
  modelOpen,
  setModelOpen,
  handleModelOpen,
  handleModelClose,
}) => {
  const classes = useStyles();
  const [name, setName] = React.useState("");
  const handleChange = (event) => {
    setName(event.target.value);
  };
  console.log(modelOpen);
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={modelOpen}
        onClose={handleModelClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modelOpen}>
          <div className={classes.paper}>
            <div className="RegistrationHeading">
              <Typography variant="h2" className="buttonBodySub">
                Registration Form
              </Typography>
              <Typography variant="h5">
                Login Please enter your login details
              </Typography>
            </div>
            <div className="SignContent">
              <Box>
                <FormControl>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    Work Email *
                  </InputLabel>
                  <br />
                  <br />
                  <br />
                  <TextField id="outlined-helperText" variant="outlined" />
                </FormControl>
              </Box>
              <Box>
                <FormControl>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    Password *
                  </InputLabel>
                  <br />
                  <br />
                  <br />
                  <TextField id="outlined-helperText" variant="outlined" />
                </FormControl>
              </Box>
            </div>
            <div className="signButtonBody">
              <div className="login-btn">
                <Button>Login</Button>
              </div>
              <Typography variant="h5" className="forgotPassword">
                Forgot Password?
              </Typography>
            </div>
            <div className="signUpBtn">
              <Button>
                Dont have an account? {""}
                <b style={{ marginLeft: "5px" }}>Register here</b>
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};
export default SignIn;
